import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { xepLoaiChungChiApi } from "../../../api/category/xepLoaiChungChiApi";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { rootActions } from "../../actions/rootActions";
import { eXepLoaiChungChiActionIds } from "../../action-types/category/IXepLoaiChungChiActions";
const mainAction= rootActions.category.xepLoaiChungChi;

export function* xepLoaiChungChiSaga(): any {
    yield takeLatest(eXepLoaiChungChiActionIds.LOAD_START, loadWorker);
    yield takeEvery(eXepLoaiChungChiActionIds.SAVE_START, saveWorker);
    yield takeEvery(eXepLoaiChungChiActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
    const res = yield call(xepLoaiChungChiApi.SelectAll);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi khi tải Xếp loại chứng chỉ"));
    }
}

function* saveWorker(action: any): any {
    let res;
    const payload = action.payload;
    if (payload.id_xep_hang > 0) {
        res = yield call(xepLoaiChungChiApi.Update, payload.id_xep_hang, payload);
    } else {
        res = yield call(xepLoaiChungChiApi.Insert, payload);
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi khi lưu Xếp loại chứng chỉ"));
    }
}

function* deleteWorker(action: any): any {
    const id = action.payload;
    const res = yield call(xepLoaiChungChiApi.Delete, id);
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi khi xóa Xếp loại chứng chỉ"));
    }
}